import { Box, type SxProps, type Theme } from '@mui/material';
import useLocalization from '../../hooks/useLocalization';
import { mergeSx } from '../../utils/styles';

const styles = {
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    lineHeight: 1,
  },
} as const;

type BetBuilderBadgeProps = {
  sx?: SxProps<Theme>;
};

const BetBuilderBadge = ({ sx }: BetBuilderBadgeProps) => {
  const { t } = useLocalization();
  const label = t('betBuilder');

  return (
    <Box aria-label={label} title={label} sx={mergeSx(styles.badge, sx)}>
      BB
    </Box>
  );
};

export default BetBuilderBadge;
